export const formatCNPJ = (val: string) => {
	// CNPJ alfanumérico (RFB jul/2026): preserva letras nas posições de dados, normaliza upper.
	const n = val.toUpperCase().replace(/[^0-9A-Z]/g, "");
	return `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8, 12)}-${n.slice(
		12,
		14,
	)}`;
};

export const formatCPF = (val: string) => {
	if (val.startsWith("*")) return val;
	const n = val.replace(/[^0-9]/g, "");
	if (n.length !== 11) return val;
	return (
		n.substring(0, 3) +
		"." +
		n.substring(3, 6) +
		"." +
		n.substring(6, 9) +
		"-" +
		n.substring(9, 11)
	);
};
